const teste = [{value: Math.random(), label: "Não Cadastrada"}]

export const useCities = (users) => {
  return users && users.length && [...new Map(users?.map((item) => [item["city"], item])).values()]
  .filter((item) => item?.city !== null)
  .map(({ city, id }, index) => ({ value: id+index, label: city })).concat(teste) || [];
}

export const getSuggestionsLocation = async (location = "municipios") => {
  return fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/${location}`)
    .then((response) => response.json())
    .then((data) =>
      data
        .map((item) => {
          return {
            value: item.id,
            label: item.nome,
          }
        })
        .filter((item) => item.label.toLowerCase().includes(value.toLowerCase())),
    )
}